import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-show-examination',
  templateUrl: './show-examination.component.html',
  styleUrls: ['./show-examination.component.scss']
})
export class ShowExaminationComponent implements OnInit {
    destroyshowexam$: Subject<boolean> = new Subject<boolean>();
  private  displayedColumns: string[] = ['drName', 'visitDate', 'drRemarks', 'nextVisitPlan', 'remarksForCounselor'];
  private  dataSource_exam = new MatTableDataSource<any>();
  private  startdate: any;
  private fdate: string;
  private tdate: string;
  private maxDate:any;
  private patientDrdetaill:any=[];
  constructor(private dialogRef: MatDialogRef<ShowExaminationComponent>,
    private emrService: EMRService, private exportdata: ExportService, private dashboardService: DashboardService,
    private authservice: AuthService,private datePipe :DatePipe,private opdvisitService: OpdVisitService) {
       
     }

  ngOnInit(): void {
    this.patientDrdetaill=[]
    this.maxDate = moment(this.authservice.getServerDate).format('YYYY-MM-DD');
   
    this.fdate = this.dashboardService.selecteddate
    this.tdate = this.dashboardService.selecteddate
    this.dataSource_exam.data=[];
    this.getExamination();
  }
  ngOnDestroy() {
    this.destroyshowexam$.next(true);
    this.destroyshowexam$.unsubscribe();
    this.maxDate=null;
    this.dataSource_exam=null;
    this.fdate=null;
    this.tdate=null;
    this.displayedColumns=null;
    this.patientDrdetaill =null;
  }
  getExamination(){
    this.emrService.GetFindingGResultByregid(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr).pipe(takeUntil(this.destroyshowexam$)).subscribe((x:any)=>{
       this.patientDrdetaill = x.filter(item => item.pK_ExamId == this.emrService.examid);
       this.dataSource_exam.data = this.patientDrdetaill.reverse();
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  closedialog() {
    this.dialogRef.close();
  }

  searchFilter(filterValue) {
    this.dataSource_exam.filter = filterValue.trim().toLowerCase();
  }

  selectExamRow(row) {
    this.dialogRef.close(row);
  }

  exportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    this.startdate = this.authservice.getServerDate;
    let element = document.getElementById('showexamcontent');
    this.exportdata.Newexportxcel(element, 'Show_Examination');
  }
  SearchRecord(){
    this.emrService.GetFindingGResultByregid(this.opdvisitService.patientdetails.pkRegId,0,0).pipe(takeUntil(this.destroyshowexam$)).subscribe((x:any)=>{
      let start = this.fdate;
      let end = this.tdate;
      if(x.length >0){
        let selectedMembers = x.filter(
          m => new Date(this.datePipe.transform(m.visitDate, "yyyy-MM-dd")) >= new Date(this.datePipe.transform(start, "yyyy-MM-dd")) && new Date(this.datePipe.transform(m.visitDate, "yyyy-MM-dd")) <= new Date(this.datePipe.transform(end, "yyyy-MM-dd"))
          );
          this.dataSource_exam.data = selectedMembers.reverse();
      }else{
        this.dataSource_exam.data=[];
      }
    
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
   
  }
}
